import { useParams } from 'react-router-dom'

import { useYoloModal } from 'lib/yoloModals/useYoloModal'
import { useEffect } from 'react'

export const useYoloBotRegister = () => {
  const { referralcode } = useParams()
  const { updateModal } = useYoloModal()

  const SIGNED_UP_FEEDBACK = {
    show: true,
    id: 'yolobotSignedUp',
  }

  const SIGN_UP_MODAL_OBJ = {
    // this component will receive `closeModal` prop to close programmatically the modal
    show: true,
    id: 'signUp',
    props: { referralCode: referralcode, onSignedUp: () => updateModal(SIGNED_UP_FEEDBACK) },
  }

  useEffect(() => {
    if (!referralcode) return
    updateModal(SIGN_UP_MODAL_OBJ)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [referralcode])
}
